export default __webpack_public_path__ + "static/media/aquasil-ultra-aquasil-ultra.e1811a8f.png";